module.exports = __webpack_public_path__ + "img/material-card3.0de71d44.png";